module.exports = __webpack_public_path__ + "static/media/illustrasi-line-dash-lamp.63a74460.svg";